var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
var SystemToolsService = /** @class */ (function () {
    function SystemToolsService() {
    }
    /**
     * 法院信息查询
     */
    SystemToolsService.prototype.queryRiskInfo = function (data) {
        return this.netService.send({
            server: domainService.systemToolsController.queryRiskInfo,
            data: data
        });
    };
    /**
     * 分页查询单个风险项
     * @param data
     * @returns
     */
    SystemToolsService.prototype.queryRiskFxContent = function (data) {
        return this.netService.send({
            server: domainService.systemToolsController.queryRiskFxContent,
            data: data
        });
    };
    /**
     * 法院信息查询混合
     * @param data
     * @returns
     */
    SystemToolsService.prototype.queryRiskInfoMixed = function (data) {
        return this.netService.send({
            server: domainService.systemToolsController.queryRiskInfoMixed,
            data: data
        });
    };
    /**
     * 下载外访根据模板
     */
    SystemToolsService.prototype.downLoadRiskInfoTemplate = function () {
        return this.netService.send({
            server: domainService.systemToolsController.downLoadRiskInfoTemplate,
        });
    };
    /**
     * excel导入法院信息查询导出
     */
    SystemToolsService.prototype.downloadRiskInfo = function (data) {
        return this.netService.send({
            server: domainService.systemToolsController.downloadRiskInfo,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], SystemToolsService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], SystemToolsService.prototype, "downLoadRiskInfoTemplate", null);
    __decorate([
        Debounce()
    ], SystemToolsService.prototype, "downloadRiskInfo", null);
    return SystemToolsService;
}());
export { SystemToolsService };
